var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imageFiles.length)?_c('b-img',{attrs:{"fluid-grow":"","src":_vm.imageFiles[0].file.public_path,"width":"64"}}):_c('design-2021-apprentice-video-player-component',{key:Math.floor(Math.random() * 100),attrs:{"options":_vm.getVideoOptions()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }